import React, { useState, useEffect, useRef } from 'react';
import { Card, Button, Tooltip, Overlay } from 'react-bootstrap';
import { FaEye, FaCamera, FaCopy, FaLock, FaCircleCheck, FaQrcode } from 'react-icons/fa6';
// import defaultImage from "../../assets/_horizontal-positivo.png"
import DropDown from "../common/customDropDown"
import { useTranslation } from "react-i18next";
import { downloadQR } from '../../utils/downloadQr';


const FormCard = ({ title, text, type, error, errorMessage, options, readOnly, copyClipBoard, onChange, setFile, defaultFile, selectedValue, limitToday, maxToday, minDate, defaultImage, centered = false, qrLink, fontSmall = false, trueOption, falseOption, smallCard = false }) => {
  const [t] = useTranslation("formcard")
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordValue, setPasswordValue] = useState(text || '');
  const [fileURL, setFileURL] = useState(null);
  const textAreaRef = useRef(null);
  const [initialFocus, setInitialFocus] = useState(false);
  const [passwordEdited, setPasswordEdited] = useState(false);
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const target = useRef(null);


  const minDateTime = limitToday ? new Date().toISOString().slice(0, 16) : null;
  const maxDateTime = maxToday ? new Date().toISOString().slice(0, 16) : null;
  const minDateRange = limitToday ? new Date().toISOString().split('T')[0] : null;
  const maxDateRange = maxToday ? new Date().toISOString().split('T')[0] : null;


  const handleOnChange = (e) => {
    if (onChange) {
      onChange(e); // Llamar a la función onChange pasada como prop
    }
  };

  const handlePasswordChange = (e) => {
    setPasswordValue(e.target.value);
    setPasswordEdited(true); // Establecer que el campo de contraseña ha sido editado
    if (onChange) {
      onChange(e);
    }
  };

  const updateTextAreaHeight = () => {
    const textArea = textAreaRef.current;
    textArea.style.overflow = 'hidden';
    textArea.style.height = 'auto';
    textArea.style.height = `${textArea.scrollHeight}px`;
  };

  const handleOnChangeTextArea = (e) => {
    if (onChange) {
      onChange(e); // Llamar a la función onChange pasada como prop
    }
    updateTextAreaHeight(); // Actualiza la altura del textarea
  };

  const handlePasswordFocus = () => {
    if (!initialFocus) {
      setInitialFocus(true);  // Establecer que el campo ha recibido foco por primera vez
      const inputElement = document.getElementById("passwordInput");
      if (inputElement) {
        inputElement.value = '';  // Limpia el valor del campo de contraseña
      }
    }
  };


  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const copyToClipboard = async () => {
    if (!text) return;

    try {
      // Intentar obtener permisos
      const { state } = await navigator.permissions.query({ name: "clipboard-write" });

      // Verificar si se tienen permisos
      if (state === "granted" || state === "prompt") {
        // Si se tienen permisos, o se podrían pedir, intentar escribir al portapapeles
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setShowTooltip(true);

        setTimeout(() => {
          setCopied(false);
          setShowTooltip(false);
        }, 4000);
      } else {
        alert(`${t("formcard.alertClipboard")}`)
        console.error("No se tienen permisos para escribir en el portapapeles.");
      }
    } catch (error) {
      // Manejar errores posibles, como el usuario negando permisos
      console.error("No se pudo copiar al portapapeles", error);
    }
  };

  function dataURItoFile() {
    const byteString = atob(defaultImage.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: 'image/png' }); // Cambia 'image/png' según el tipo de archivo que sea
    return new File([blob], 'image.png');
  }



  const handleFileChange = async (e) => {
    const selectedFile = e.target ? e.target.files[0] : e;
    if (!selectedFile) {

      return;
    }

    const url = URL.createObjectURL(selectedFile);

    let img;
    let fileSizeKB;

    if (selectedFile) {
      img = new Image();

      // Esperar hasta que la imagen se haya cargado
      await new Promise((resolve) => {
        img.onload = resolve;
        img.src = url;
      });

      fileSizeKB = Math.round((selectedFile.size / 1024) * 100) / 100;

    }

    setFile(selectedFile);
    setFileURL(url);

    if (onChange && img && fileSizeKB) {
      //devuelvo lo que me interesa para los errores
      onChange(selectedFile)
      // onChange({ width: img.width, height: img.height, size: fileSizeKB });
    }
  };

  useEffect(() => {
    if (defaultImage) {
      const file = dataURItoFile();

      setFile(file);

      handleFileChange(file);
    }

  }, [defaultImage]);


  useEffect(() => {
    if (type === 'textarea') {
      updateTextAreaHeight(); // Actualiza la altura al inicio y cuando cambie el texto
    }
  }, [text, type]);

  const commonStyles = {
    background: 'transparent',
    border: 'none',
    outline: 'none',
    resize: 'none',
    borderBottom: '1px solid #555555',
    width: '100%'
  };

  const readOnlyStyles = {
    ...commonStyles,
    pointerEvents: 'none',
    cursor: 'default'
  };

  const readOnlyTextAreaStyles = {
    ...readOnlyStyles,
    resize: 'none', // Para que no se pueda redimensionar
    overflow: 'hidden', // Para manejar el desbordamiento de texto
  };


  const appliedStyles = readOnly ? readOnlyStyles : commonStyles;
  const appliedTextAreaStyles = readOnly ? readOnlyTextAreaStyles : commonStyles;

  return (
    <Card className={`mt-4 custom-shadow form-card-container ${type === 'qr' && 'form-card-qr-code-container'}`} onClick={() => { if (type === 'qr') downloadQR(qrLink); }}>
      <Card.Body className={` ${smallCard && 'form-card-small-body'}`}>
        <Card.Title className={`form-card-title ${!readOnly && error ? 'form-card-title-error' : ''}`} >
          {title}
          {readOnly ?
            <FaLock className='form-card-lock' size={12} />
            : null}
        </Card.Title>
        <div className="form-card-content">
          {type === 'text' ? (
            <>
              <input
                defaultValue={text}
                type="text"
                style={appliedStyles}
                className={`${error ? 'form-card-input-error ' : ''}  ${centered ? 'text-center' : ''}`}
                readOnly={readOnly}
                onInput={handleOnChange} // Agregar esto aquí
              />
              {copyClipBoard && (
                <>
                  <span ref={target}>
                    {copied ? (
                      <FaCircleCheck className='form-card-icon-copied' size={19} onClick={copyToClipboard} />
                    ) : (
                      <FaCopy className='form-card-icon-copy' onClick={copyToClipboard} size={17} />
                    )}
                  </span>
                  <Overlay target={target.current} show={showTooltip} placement="top">
                    {(props) => (
                      <Tooltip className='overlay-copied' id="overlay-copied" {...props}>
                        {t("formcard.clipboardCopied")}
                      </Tooltip>
                    )}
                  </Overlay>
                </>
              )}
              <span className='form-card-input-error-text'>{error ? errorMessage : null}</span>
            </>
          ) : type === 'href' ? (
            <>
              <a href={text} target='_blank' className={`form-card-href w-100 color-custom-secondary ${fontSmall && 'overflow-link'}`}>{text}</a>
              {copyClipBoard && (
                <>
                  <span ref={target}>
                    {copied ? (
                      <FaCircleCheck className='form-card-icon-copied' size={19} onClick={copyToClipboard} />
                    ) : (
                      <FaCopy className='form-card-icon-copy' onClick={copyToClipboard} size={17} />
                    )}
                  </span>
                  <Overlay target={target.current} show={showTooltip} placement="top">
                    {(props) => (
                      <Tooltip className='overlay-copied' id="overlay-copied" {...props}>
                        {t("formcard.clipboardCopied")}
                      </Tooltip>
                    )}
                  </Overlay>
                </>
              )}
            </>
          ) : type === 'date' ? (
            <>
              <input
                defaultValue={text}
                type="datetime-local"
                min={minDateTime}
                max={maxDateTime}
                style={appliedStyles}
                className={`${error ? 'form-card-input-error ' : ''}`}
                readOnly={readOnly}
                onChange={handleOnChange} // Agregar esto aquí
              />
              <span className='form-card-input-error-text'>{error ? errorMessage : null}</span>
            </>
          ) : type === 'date-range' ? (
            <>
              <input
                defaultValue={text}
                type="date"
                min={minDate ? minDate : minDateRange}
                max={maxDateRange}
                style={appliedStyles}
                className={`${error ? 'form-card-input-error ' : ''}`}
                readOnly={readOnly}
                onChange={handleOnChange} // Agregar esto aquí
              />
              <span className='form-card-input-error-text'>{error ? errorMessage : null}</span>
            </>
          ) : type === 'textarea' ? (
            <>
              <textarea
                ref={textAreaRef}
                defaultValue={text}
                style={appliedTextAreaStyles}
                className={`${error ? 'form-card-input-error ' : ''}`}
                readOnly={readOnly}
                onChange={handleOnChangeTextArea} // Agregar esto aquí
                rows="1"  // Inicialmente sólo 1 fila, luego será ajustado automáticamente
              />
              <span className='form-card-input-error-text'>{error ? errorMessage : null}</span>
            </>
          ) : type === 'select' ? (

            <>
              <DropDown
                options={options}
                readOnly={readOnly}
                error={error}
                selectedValue={
                  selectedValue && selectedValue.label && selectedValue.value
                    ? { label: selectedValue.label, value: selectedValue.value }
                    : null
                }
                onChange={handleOnChange}
              />
              <span className='form-card-input-error-text'>{error ? errorMessage : null}</span>

            </>

          ) : type === 'password' ? (
            <>
              <input
                id="passwordInput"  // Añade un ID para poder seleccionar el elemento
                defaultValue={text}
                type={passwordVisible ? 'text' : 'password'}
                style={appliedStyles}
                readOnly={readOnly}
                onChange={handlePasswordChange}
                onFocus={handlePasswordFocus}
              />
              {!readOnly && passwordEdited && (
                <FaEye
                  className='form-card-icon'
                  onClick={togglePasswordVisibility}
                />
              )}
            </>
          ) : type === 'file' ? (
            <>
              {fileURL ? (
                <img src={fileURL} alt="Uploaded" style={{ width: '100%', marginBottom: '10px' }} />
              ) : defaultFile ? (
                <img src={defaultImage} alt="Default" style={{ width: '80%', margin: '10px', alignSelf: "center" }} />
              ) : (
                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                  <FaCamera size={170} color="grey" />
                </div>
              )}
              <p><center><span className='form-card-input-error-text'>{error ? errorMessage : null}</span></center></p>

              <div style={{ textAlign: 'center' }}>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  id="fileInput"
                  readOnly={readOnly}
                  onChange={handleFileChange}
                  accept="image/png"
                />
                <Button variant="success" className='custom-button-primary custom-shadow' onClick={() => document.getElementById('fileInput').click()}>
                  {t("formcard.edit")}
                </Button>
              </div>
            </>
          ) : type === 'qr' ? (
            <>

              <div className='text-center' >
                <FaQrcode className='form-card-qr-code-icon' />
              </div>
            </>
          ) : type === 'switch' ? (
            <>

              <div className='text-center' >
                SÍ
              </div>
            </>
          ) : null}
        </div>
      </Card.Body>
    </Card>
  );
};

export default FormCard;
